/**
 * Runtime environment values for the LabFlow UI.
 *
 * Every key MUST be prefixed with `VITE_` to be exposed to client
 * code (Vite convention). See `.env.example`.
 */
export const environment = {
  msal: {
    clientId:              import.meta.env.VITE_MSAL_CLIENT_ID as string,
    tenantId:              import.meta.env.VITE_MSAL_TENANT_ID as string,
    redirectUri:           import.meta.env.VITE_MSAL_REDIRECT_URI as string,
    postLogoutRedirectUri: import.meta.env.VITE_MSAL_POST_LOGOUT_REDIRECT_URI as string,
    apiScope:              import.meta.env.VITE_MSAL_API_SCOPE as string,
  },
  labFlowApi: {
    baseUrl: import.meta.env.VITE_LABFLOW_API_BASE_URL as string,
  },
  gatewaysApi: {
    baseUrl: import.meta.env.VITE_GATEWAYS_API_BASE_URL as string,
  },
  appInsights: {
    connectionString:
      (import.meta.env.VITE_APP_INSIGHTS_CONNECTION_STRING as string | undefined) ?? '',
  },
  /** True only in Vite dev mode when VITE_AUTH_BYPASS=true — bypasses Entra login. */
  authBypass: import.meta.env.DEV && import.meta.env.VITE_AUTH_BYPASS === 'true',
} as const;
